import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthContext } from 'Shared/Security/Domain/Contexts/authContext';
import { PRIVATE } from 'Shared/Routing/Application/Constants/PathsConstant';
import { ADMIN_CS, EXTRAS } from 'Shared/Security/Application/Constants/PermissionsConstant';

export default function ExtraRoute() {
  const { checkPermission, isAdmin } = useAuthContext();

  if (!checkPermission(ADMIN_CS) && !checkPermission(EXTRAS) && !isAdmin()) {
    return <Navigate to={PRIVATE} />;
  }

  return <Outlet />;
}
